import CombinedWindSolar from "../Charts/CombinedWindSolar";
import SupplyAndDemandChart from "../Charts/SupplyAndDemand";
import FuelMix from "../Charts/FuelMix";
import GenerationOutages from "../Charts/GenerationOutages";
import Interchange from "../Charts/Interchange";
import RealTimeTotalLoad from "../Charts/RealTimeTotalLoad";
import RegionalDirectionalTransfer from "../Charts/RegionalDirectionalTransfer";
import ReserveReq from "../Charts/NextDayShortTermReserveRequirement";
import Disclaimer from "../Components/Disclaimer";
import Pod from "../Components/Pod";
import AreaControlError from "../Charts/AreaControlError";
import RealTimeReserveMargin from "../Charts/RealTimeReserveMargin";

export default function OperationsDisplays() {
    return (
        <>
            <div className="podContainer">
                <div className="chart-row">
                    <div className="column-2">
                        <Pod title="Fuel Mix" 
                            Chart={FuelMix}
                            showPopout={true}
                            hideDisclaimer={true} />
                    </div>
                    <div className="column-2">
                        <Pod title="Supply and Demand" 
                             Chart={SupplyAndDemandChart} 
                             showPopout={true}
                             hideDisclaimer={true} />
                    </div>
                </div>
                <div className="chart-row">
                    <div className="column-2">
                        <Pod title="Real-Time Total Load" 
                            Chart={RealTimeTotalLoad} 
                            showPopout={true}
                            hideDisclaimer={true} />
                    </div>
                     <div className="column-2">
                        <Pod title="Next-Day Short-Term Reserve Requirement" 
                            Chart={ReserveReq} 
                            showPopout={true} 
                            hideDisclaimer={true} />
                    </div>
                </div>
                <div className="chart-row">
                    <div className="column-2">
                        <Pod title="Wind and Solar Forecast and Real-Time Generation"
                        Chart={CombinedWindSolar} 
                             showPopout={true}
                             hideDisclaimer={true}
                             chartSpecificProps={{"twoDays": "true"}} />
                    </div>
                    <div className="column-2">
                        <Pod title="Region-Wide Total Imports(-)/Exports(+)"
                        Chart={Interchange} 
                             showPopout={true}
                             hideDisclaimer={true} />
                    </div>
                </div>
                <div className="chart-row">
                    <div className="column-2">
                        <Pod title="Regional Directional Transfer"
                        Chart={RegionalDirectionalTransfer} 
                             showPopout={true}
                             hideDisclaimer={true} />
                    </div>
                    <div className="column-2">
                        <Pod title="Generation Outages"
                        Chart={GenerationOutages} 
                             showPopout={true}
                             hideDisclaimer={true} />
                    </div>
                </div>
				<div className='chart-row'>
					<div className='column-2'>
						<Pod title='Area Control Error'
                             Chart={AreaControlError}
                             showPopout={true}
                             hideDisclaimer={true} />
					</div>
					<div className='column-2'>
						
					</div>
				</div>
                <div className='chart-row'>
					<div className='column-1'>
						<Pod title='Real-Time Reserve Margin'
                             Chart={RealTimeReserveMargin}
                             showPopout={true}
                             hideDisclaimer={true} />
					</div>
				</div>
            </div>
            <Disclaimer  extraMargin={true}/>
        </>
    )
}
